export const SIZE = {
  width: 500,
  height: 500,
}; 